export const cLength = (len: number, val?: string) => {
  if (typeof val === 'string') {
    return val.length < len;
  } else {
    return true;
  }
};


export const CLIMITS = {
  body: 180,
  question: 120,
  questionShort: 50,
  highlights: 150,
  tips: 150
};

export const CTEXT = (value: any, name: string): string => {
  if (typeof value !== 'string') {
    return '';
  }
  if (!CLIMITS.hasOwnProperty(name)) {
    return `No limit for "${name}"`;
  } else {
    const limit: number = (CLIMITS as any)[name];
    return `(${value.length}/${limit})`;
  }
}
